export const PAYMENT_METHOD_COMPONENT_TYPES = {
  PROFILE: 'profile',
  RESERVE: 'reserve',
  EDIT_VIEW: 'editView',
};
